import { ReactNode } from 'react';

import { Box, Divider, Paper, Stack, Typography } from '@mui/material';

// email, roles and actions columns; on mobile the roles and actions wrap onto their own lines below the email
export const rowSx = {
  display: 'grid',
  gridTemplateColumns: { xs: 'minmax(0, 1fr) 64px', sm: 'minmax(0, 1fr) minmax(0, 1fr) 200px' },
  gap: { xs: 1, sm: 2 },
  alignItems: 'center',
  px: { xs: 2, sm: 4 },
  py: 2,
};

export const rolesCellSx = { gridColumn: { xs: '1 / -1', sm: 'auto' }, order: { xs: 1, sm: 0 } };

export const actionsCellSx = {
  gridColumn: { xs: '1 / -1', sm: 'auto' },
  order: { xs: 2, sm: 0 },
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1,
};

type TableCardProps = {
  firstHeader: string;
  children: ReactNode;
};

export function TableCard({ firstHeader, children }: TableCardProps): JSX.Element {
  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <Box
        sx={{
          ...rowSx,
          display: { xs: 'none', sm: 'grid' },
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'grey.100',
        }}
      >
        <Typography variant="subtitle2" color="text.secondary">
          {firstHeader}
        </Typography>
        <Typography variant="subtitle2" color="text.secondary">
          Roles
        </Typography>
        <Box />
      </Box>
      <Stack divider={<Divider />}>{children}</Stack>
    </Paper>
  );
}
